import { render, staticRenderFns } from "./DisplayUser.vue?vue&type=template&id=34c40a13&scoped=true"
import script from "./DisplayUser.vue?vue&type=script&lang=js"
export * from "./DisplayUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c40a13",
  null
  
)

export default component.exports